import styled from '@xstyled/styled-components'

export const StyledRecorderButtonRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  'button:not(:last-of-type)': {
    marginRight: 32
  }
})
